// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "js/" + chunkId + "." + {"72":"ef07c69b","96":"8828ad79"}[chunkId] + ".js";
};